import { useCallback } from 'react';
export function useForwardedRef(...refs) {
    const setRefByType = (ref, refToAssign) => {
        if (typeof ref === 'function') {
            ref(refToAssign);
        }
        else if (ref) {
            ref.current = refToAssign;
        }
    };
    const setRef = useCallback((ref) => {
        refs.forEach((refCallback) => setRefByType(refCallback, ref));
    }, []);
    return setRef;
}
//# sourceMappingURL=useForwardedRef.js.map